import { OktaAuth } from '@okta/okta-auth-js';

import OktaAuthConfig from 'Config/OktaConfig';

const oktaClient = new OktaAuth(OktaAuthConfig);
oktaClient.start();

export default oktaClient;
